import { apiConfig } from "core-lib/config/config";
import { getMethod } from "core-lib/utils/apiV2";

const SEO_BASE_URL = apiConfig('seoService');

export const getAutoCompleteSuggestions = async (searchText) => {
  const url = `${SEO_BASE_URL}/api/v1/auto-complete?text=${searchText}`;
  const { response }: any = await getMethod({ endPoint: url });
  if (response?.data?.length) {
    return response?.data || [];
  }
  return [];
};
